import { Button, Modal, Text, ThemeIcon, Title } from "@mantine/core";
import clsx from "clsx";

interface PopupProps {
	id?: string;
	isOpen: boolean;
	onClose: () => void;
	title: string;
	description: string;
	IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>;
	accentColor: string;
	iconBackroundColor: string;
	secondaryColor: string;
	actionButtonText: string;
	cancelButtonText: string;
	onActionConfirm: (id?: string) => void;
	onActionCancel: () => void;
	isActionLoading?: boolean;
}

function Popup(props: PopupProps) {
	const { IconComponent, isActionLoading = false } = props;
	return (
		<Modal
			opened={props.isOpen}
			onClose={props.onClose}
			withCloseButton={false}
			radius="md"
			size="lg"
			centered
			zIndex={9999}
			closeOnClickOutside={!isActionLoading}
			closeOnEscape={!isActionLoading}
		>
			<div className="flex flex-col items-center p-2 mt-2">
				<ThemeIcon
					variant="filled"
					style={{
						backgroundColor: `${props.iconBackroundColor}`,
						color: `${props.accentColor}`,
					}}
					className="w-16 h-16 rounded-full"
				>
					<IconComponent className="w-[60%] h-[60%]" />
				</ThemeIcon>
				<Title className="mt-4 text-center" order={3}>
					{props.title}
				</Title>
				<Text
					style={{ color: props.secondaryColor }}
					className="my-4 w-full text-center wrap-break-word text-balance"
					size="lg"
				>
					{props.description}
				</Text>
				<div className="flex mt-2 space-x-4 w-full">
					<Button
						variant="outline"
						size="md"
						radius="md"
						onClick={props.onActionCancel}
						disabled={isActionLoading}
						className={clsx(
							"grow w-full border-border-default text-text-primary",
							"hover:bg-surface-subtle",
						)}
					>
						{props.cancelButtonText}
					</Button>
					<Button
						variant="filled"
						color={props.accentColor}
						size="md"
						radius="md"
						onClick={() => props.onActionConfirm(props.id)}
						loading={isActionLoading}
						disabled={isActionLoading}
						className="grow w-full text-white"
					>
						{props.actionButtonText}
					</Button>
				</div>
			</div>
		</Modal>
	);
}

export default Popup;
